import { jsx as _jsx } from "react/jsx-runtime";
export function SVG(props) {
    if (!props.svg)
        return null;
    return (_jsx("g", { dangerouslySetInnerHTML: {
            __html: props.svg,
        } }));
}
//# sourceMappingURL=SVG.js.map